export default __webpack_public_path__ + "static/media/CatwikiLogo.92dea8ab.svg";